// src/services/api.js
import axios from 'axios';

const baseURL = process.env.VUE_APP_API_URL;

// console.log('API Base URL:', baseURL); // For debugging

const apiClient = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 100000,
});


// For file uploads, we'll use a longer timeout
export const fileUploadClient = axios.create({
  baseURL,
  timeout: 300000, // 5 minutes for file uploads
});


apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('jwt');
      localStorage.removeItem('userdata');
      // window.location.href = '/auth/signin-basic';
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Add the same interceptors as your regular apiClient
fileUploadClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

fileUploadClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('jwt');
      localStorage.removeItem('userdata');
      window.location.href = '/auth/signin-basic';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
